import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PictureService {

  // Crear un subject que emita el nombre de la imagen clicada
  private imageClickedSource = new Subject<string>();

  // Crear un observable que se pueda suscribir
  imageClicked$ = this.imageClickedSource.asObservable();

  constructor() { }

  // Crear una función que reciba el nombre de la imagen y lo emita al subject
  emitImageClicked(imageName: string) {
    this.imageClickedSource.next(imageName);
  }
}